import { __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import { defaultProjectApiUrl } from '../../client/client.js';
import { OystehrSdkError } from '../../errors/index.js';

function baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
}
/**
 * Uploads a file to the bucket and key. Files should be Blobs.
 *
 * @param params upload file params
 */
function uploadFile({ bucketName, 'objectPath+': key, file, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const uploadUrl = yield this.request('/z3/{bucketName}/{objectPath+}', 'post', baseUrlThunk.bind(this))({
            action: 'upload',
            bucketName,
            'objectPath+': key,
        });
        yield fetch(uploadUrl.signedUrl, {
            method: 'PUT',
            body: file,
        });
    });
}
/**
 * Downloads an object matching the bucket and key. File content is returned as an ArrayBuffer.
 *
 * @param params download file params
 */
function downloadFile({ bucketName, 'objectPath+': key, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const uploadUrl = yield this.request('/z3/{bucketName}/{objectPath+}', 'post', baseUrlThunk.bind(this))({
            action: 'download',
            bucketName,
            'objectPath+': key,
        });
        const resp = yield fetch(uploadUrl.signedUrl, {
            method: 'GET',
        });
        if (!resp.ok) {
            throw new Error('Failed to download file');
        }
        return resp.arrayBuffer();
    });
}
/**
 * This helper performs a `getPresignedUrl` request for Z3 URLs of the forms
 * `https://projects-api.oystehr.com/v1/z3/<bucket>/<key>` or `z3://<bucket>/<key>`
 * instead of the standard SDK `Z3GetPresignedUrlParams`.
 *
 * @param params url and action
 */
function getPresignedUrlForZ3Url(params) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        let bucket;
        let key;
        const url = new URL(params.url);
        if (url.protocol === 'z3:') {
            // remove leading forward slash
            const z3PathParts = url.pathname.split('/').slice(1);
            bucket = url.hostname;
            key = z3PathParts.join('/');
        }
        else if (url.href.startsWith((_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : defaultProjectApiUrl)) {
            // remove leading `/v1/z3`
            const httpsPathParts = url.pathname.split('/').slice(3);
            bucket = httpsPathParts[0];
            key = httpsPathParts.slice(1).join('/');
        }
        else {
            throw new OystehrSdkError({ message: 'Invalid Z3 URL', code: 400 });
        }
        const requestParams = {
            action: 'upload',
            bucketName: bucket,
            'objectPath+': key,
        };
        return this.request('/z3/{bucketName}/{objectPath+}', 'post', baseUrlThunk.bind(this))(requestParams);
    });
}

export { downloadFile, getPresignedUrlForZ3Url, uploadFile };
//# sourceMappingURL=z3-ext.js.map
